module.exports = __webpack_public_path__ + "media/images/sp/stores/kobe/kobe_sns_01-29b46db282dacc8bac7918410b74155f.jpg";